export const contentTableConfig = {
  title: '内容中心快捷回复列表',
  propList: [
    {
      prop: 'templateTypeName',
      label: '类型',
      minWidth: '40'
    },
    {
      prop: 'templateTitle',
      label: '模版标题',
      minWidth: '80',
    },
    {
      prop: 'question',
      label: '问题',
      minWidth: '80',
      slotName: 'question'
    },
    {
      prop: 'trackingThought',
      label: '跟踪思路',
      minWidth: '80',
      slotName: 'trackingThought'
    },
    {
      prop: 'numOfClicks',
      label: '点击量',
      minWidth: '40',
      slotName: 'numOfClicks'
    },
    {
      prop: 'serialNumber',
      label: '排序',
      minWidth: '40',
    },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '100',
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
